import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotificationInboxContent from './NotificationInboxContent';
import { selectIsPopupOpen } from '../../../Redux/toggle';
import {
  readNotificationsBackground,
  clearNotificationsBackground,
  pathFromBackground,
} from '../../../utils/notificationsBackground';

/**
 * Full-height notifications panel overlay (Figma 13001:35150).
 * Portaled + position:fixed so it always paints above the current page.
 */
const NotificationOverlay = () => {
  const navigate = useNavigate();
  const isSidebarCollapsed = useSelector(selectIsPopupOpen);
  const sidebarWidth = isSidebarCollapsed ? 64 : 280;

  const handleClose = useCallback(() => {
    const background = readNotificationsBackground();
    clearNotificationsBackground();
    navigate(pathFromBackground(background), { replace: true });
  }, [navigate]);

  const panel = (
    <>
      <Box
        onClick={handleClose}
        aria-hidden
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: `${sidebarWidth}px`,
          zIndex: 1200,
          backgroundColor: 'transparent',
        }}
      />
      <Box
        role="dialog"
        aria-label="Notifications"
        sx={{
          position: 'fixed',
          top: 0,
          left: `${sidebarWidth}px`,
          bottom: 0,
          width: '424px',
          maxWidth: `calc(100vw - ${sidebarWidth}px)`,
          zIndex: 1201,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#FFF',
          borderLeft: '1px solid #E5E9EC',
          borderRight: '1px solid #E5E9EC',
          boxShadow: '15px 0px 20px 0px rgba(6, 21, 34, 0.05)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          sx={{
            flexShrink: 0,
            padding: '24px 16px 8px 16px',
          }}
        >
          <Typography
            sx={{
              color: '#061522',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '18px',
            }}
          >
            Notifications
          </Typography>
        </Box>

        <NotificationInboxContent
          open
          onNavigateAway={clearNotificationsBackground}
          avatarSize={40}
        />
      </Box>
    </>
  );

  return createPortal(panel, document.body);
};

export default NotificationOverlay;
